import User from 'entities/user/model';
import {
  computeDonationProviderForNonprofit,
  isPotentiallyDonatableViaNfg,
} from 'utils/computeDonationProviderForNonprofit';
import { Privileges } from 'utils/privileges';
import Organization from 'entities/organization/model';

import { VerificationMachineContext } from './machine';

export const getVerificationMachineContext = (
  user: User,
  code: string | undefined,
  verifyWithPayPalService: () => Promise<{
    privileges: Privileges[];
    nonprofit: Partial<Organization>;
  }>
): VerificationMachineContext => ({
  privileges: user.privileges,
  nonprofit: {
    donationProvider: computeDonationProviderForNonprofit(user.organization, false),
    isPotentiallyNfgEligible: isPotentiallyDonatableViaNfg(user.organization),
    isPayPalEnrolled: ['PPGF_ENROLLED', 'DIRECT_MODEL_ENROLLED'].includes(
      user.organization.paypalCharityType
    ),
    donationProviders: user.organization.donationProviders,
    nonprofitEntityType: user.organization.nonprofitEntityType,
    isVerified: user.organization.verificationStatus === 'active',
    isChapter: Boolean(user.organization.parent),
    governmentInformationLetterUploaded: user.organization?.governmentInformationLetterUploaded,
    isParentClaimed: user.organization.isParentClaimed,
    isInBMF: Boolean(user.organization.taxonomy?.irsClassificationCode),
  },
  proofOfAssociationUploaded: Boolean(
    (
      user.additionalData?.get('proofOfAssociation') as Array<{ file: string; nonprofitId: string }>
    )?.filter((association) => association.nonprofitId === user.organization.id)?.length
  ),
  payPalVerificationCode: code,
  verifyWithPayPalService,
});
